import { render, staticRenderFns } from "./TeamCompetitionDetail.vue?vue&type=template&id=aca2938a&scoped=true&"
import script from "./TeamCompetitionDetail.vue?vue&type=script&lang=js&"
export * from "./TeamCompetitionDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeamCompetitionDetail.vue?vue&type=style&index=0&id=aca2938a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca2938a",
  null
  
)

export default component.exports